import { LessonFormat, TARGET_SECTION } from '@lessonPlanner/prompts';

import { Section } from '../types/section';

export const ACTIVITY_SECTION_PER_FORMAT: Partial<
  Record<LessonFormat, Section>
> = {
  [LessonFormat.CODE_4A]: {
    sectionTitleEnglish: TARGET_SECTION.ACTIVITY,
    sectionTitleFilipino: TARGET_SECTION.AKTIBIDAD,
  },
  [LessonFormat.CODE_5E]: {
    sectionTitleEnglish: TARGET_SECTION.EXPLORE,
    sectionTitleFilipino: TARGET_SECTION.PAGTUKLAS,
  },
  [LessonFormat.CODE_7E]: {
    sectionTitleEnglish: TARGET_SECTION.EXPLORE,
    sectionTitleFilipino: TARGET_SECTION.PAGTUKLAS,
  },
  [LessonFormat.CODE_IPLAN]: {
    sectionTitleEnglish: TARGET_SECTION.ACTIVITY,
    sectionTitleFilipino: TARGET_SECTION.AKTIBIDAD,
  },
  [LessonFormat.CODE_M]: {
    sectionTitleEnglish:
      TARGET_SECTION.DEVELOPING_UNDERSTANDING_OF_THE_KEY_IDEA,
    sectionTitleFilipino: TARGET_SECTION.PAGPAPAUNLAD_NG_KAALAMAN,
  },
};

export const ACTIVITIES_PAGE_DESCRIPTION = `
Elevate your teaching with custom activities.
This flexibility empowers you to create dynamic learning experiences that resonate with your students on a deeper level.`;
export const ACTIVITIES_PAGE_OBJECTIVES = 'What is the activity about?';
